module.exports = __webpack_public_path__ + "img/clients.e58fc456.svg";